import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { useConfiguration } from '../../context/configurationContext';
import { isArrayLength } from '../../util/genericHelpers';
import { useIntl } from '../../util/reactIntl';

import css from './LandingPage.module.css';

//Static assets
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';

//Section pages
import SectionHero from './SectionHero';
import SectionMoreLinks from './SectionMoreLinks';
import SectionFeaturedHomes from './SectionFeaturedHomes';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import SectionPropertyInfo from './SectionPropertyInfo';
import SectionCategoryLinks from './SectionCategoryLinks';

export const LandingPageComponent = props => {
  const { scrollingDisabled, history, listings } = props;

  const config = useConfiguration();
  const intl = useIntl();
  const values = { marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.metaTitle' }, values);
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.metaDescription' }, values);
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  const [scroll, setScroll] = useState(false);
  const isHeaderSticky = scroll ? css.sticky : '';
  useEffect(() => {
    let isMounted = true;
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        if (isMounted) {
          setScroll(window.scrollY > 0);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        isMounted = false; // This is the cleanup for event listener
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer isWhiteBgNav={true} isHeaderSticky={isHeaderSticky} />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <SectionHero isLandingPage history={history} />
          <SectionPropertyInfo />
          <SectionCategoryLinks />
          {isArrayLength(listings) ? <SectionFeaturedHomes listings={listings} /> : null}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { currentPageResultIds } = state.LandingPage;
  const listings = getListingsById(state, currentPageResultIds);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    listings,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const LandingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport
)(LandingPageComponent);

export default LandingPage;
